export default "__VITE_ASSET__CMYY7sR$__"